import { Link } from "react-router-dom";
import type { VideoItem } from "@/mocks/videos";
import VideoCard from "@/components/feature/VideoCard";

interface HotVideosProps {
  videos: VideoItem[];
}

export default function HotVideos({ videos }: HotVideosProps) {
  return (
    <section className="w-full">
      <div className="flex items-end justify-between mb-5">
        <div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 flex items-center gap-2">
            <i className="ri-fire-line text-primary-500"></i>
            热门视频
          </h2>
          <p className="text-sm text-foreground-500 mt-1">按推荐算法为你精选近期高人气内容</p>
        </div>
        <Link
          to="/search?q=热门"
          className="hidden sm:flex items-center gap-1 text-sm text-accent-600 hover:text-accent-700 transition-colors whitespace-nowrap"
        >
          查看更多
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-product-shop>
        {videos.map((video) => (
          <VideoCard key={video.id} video={video} showCategory />
        ))}
      </div>
    </section>
  );
}